/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLastIntakeSheetResource } from './userLastIntakeSheetResource';
import { UserLastIntakeSheet200ResponseMeta } from './userLastIntakeSheet200ResponseMeta';


export interface UserLastIntakeSheet200Response { 
    data: UserLastIntakeSheetResource;
    meta: UserLastIntakeSheet200ResponseMeta;
}

